<ng-container *ngIf="error">
	<div *ngIf="isTriangle" class="triangle"></div>
	<p *ngIf="error">{{error}}</p>
</ng-container>